import { Box, Grid, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import Section from 'modules/contracts/components/ContractDetails/Section'
import BlankSection from 'modules/contracts/components/ContractDetails/Section/Blank'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type CustomFieldValue from 'modules/custom_resources/store/models/customFields/Value'
import type Employee from 'modules/employees/store/models/Employee'
import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'

import ContractObservations from './ContractObservations'
import CustomFields from './CustomFields'

interface Props {
  loading: boolean
  contractVersion: ContractVersion
  employee: Employee
  customFields: ResourceField[]
  customValues: CustomFieldValue[]
}

const Loading = () => {
  return (
    <Box width="full" height="full" justifyContent="center" alignItems="center" padding="s16">
      <Spinner />
    </Box>
  )
}

const OtherContractInformation = ({
  loading,
  contractVersion,
  employee,
  customFields,
  customValues,
}: Props) => {
  const contractObservations = contractVersion.attributes.es_contract_observations ?? undefined
  const canEdit = policyAuthorizations.for('contracts.edit', employee)
  const hasCustomFields = customFields.length > 0
  const hasCustomFieldsData = customValues.length > 0

  const showEmptySlate =
    canEdit && !hasCustomFields && !hasCustomFieldsData && !contractObservations
  const showContractObservations =
    !showEmptySlate && contractVersion.isSpanish && (canEdit || !!contractObservations)
  const showCustomFields = !showEmptySlate && hasCustomFields
  const showSection = showContractObservations || showCustomFields
  if (!loading && !showSection && !showEmptySlate) return <></>

  return (
    <Section icon="inbox" title={i18n.t('contract_versions.other_information.title')}>
      {loading && <Loading />}
      {!loading && (
        <Grid variant="fixed">
          {showCustomFields && (
            <CustomFields customFields={customFields} customValues={customValues} />
          )}
          {showContractObservations && <ContractObservations observations={contractObservations} />}
          {showEmptySlate && (
            <BlankSection
              employee={employee}
              contractVersion={contractVersion}
              icon="inbox"
              title={i18n.t('contract_versions.other_information.blank_slate.title')}
              description={i18n.t('contract_versions.other_information.blank_slate.description')}
              buttonText={i18n.t('contract_versions.other_information.blank_slate.button')}
            />
          )}
        </Grid>
      )}
    </Section>
  )
}

export default observer(OtherContractInformation)
